import { useTypedQuery } from "hooks";
import { WebhooksQueryKeys } from "modules/WebhooksDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useTriggersQuery = () =>
  useTypedQuery({
    queryKey: WebhooksQueryKeys.triggers,
    queryFn: async () => (await ApiInstance.get(WebhooksQueryKeys.triggers.endpoint, WebhooksQueryKeys.triggers.baseUrl)).data.webhook_triggers
  });
